import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

export const PageSection = styled.section.attrs(({ $off }) => ({
  'data-alt': $off ? 'true' : undefined,
}))`
  min-width: 0;
  padding: var(--pad, 96px) 0;
  font: 400 16px/1.6 ${getToken('font-family-default')};
  color: rgb(${getToken('color-text-primary')});
  background: ${({ $off }) =>
    $off
      ? `rgb(${getToken('color-background-secondary')})`
      : `rgb(${getToken('color-background-primary')})`};
  border-block: ${({ $off }) =>
    $off ? `1px solid rgb(${getToken('color-background-tertiary')})` : '0'};

  &:not([data-alt]) + &:not([data-alt]) {
    padding-top: 0;
  }

  /* consecutive alternate sections share a single divider */
  &[data-alt] + &[data-alt] {
    border-top: 0;
  }

  &[data-alt]:has(+ &[data-alt]) {
    border-bottom: 0;
  }
`;

export const PageSectionInner = styled.div`
  width: min(
    ${({ $read }) => ($read ? 'var(--read, 960px)' : 'var(--wide, 1200px)')},
    100% - var(--gut, 40px)
  );
  margin-inline: auto;
`;

export const PageSectionTitle = styled.h2`
  font: 700 clamp(28px, 3.2vw, 36px) / 1.2 ${getToken('font-family-title')};
  letter-spacing: -0.015em;
  color: rgb(${getToken('color-primary-60')});
  text-align: center;
  text-wrap: balance;
  margin: 0;
`;

export const PageSectionLead = styled.p`
  font: 500 clamp(17px, 1.6vw, 20px) / 1.8 ${getToken('font-family-default')};
  color: rgb(${getToken('color-text-primary')});
  text-align: center;
  max-width: min(736px, 36em);
  margin: 20px auto 0;
  text-wrap: pretty;
`;
